import React, {useContext} from "react";
import Typography from "@mui/material/Typography";
import {CardActionArea, CardMedia} from "@mui/material";
import Grid from "@mui/material/Grid";
import Section from "../common/Section";
import {LanguageContext} from "../../context/LanguageContext";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {CustomerContext} from "../../context/CustomerContext";
import {env, instance} from "../../properties";
import dcImage from "../../assets/images/dc.jpeg";
import perfmonImage from "../../assets/images/perfmon.jpeg";
import sdwanImage from "../../assets/images/sdwan.jpeg";
import ddosImage from "../../assets/images/ddos.jpeg";
import dnsImage from "../../assets/images/dns.jpeg";
import kubernetesImage from "../../assets/images/kubernetes.jpeg";
import socImage from "../../assets/images/soc.jpg";
import Link from "@mui/material/Link";
import Rendered from "../Rendered";

const HomeMenuCards = () => {
  const languageContext = useContext(LanguageContext);
  const customerContext = useContext(CustomerContext);

  // homePageCards needs to be here because of env and instance
  const homePageCards = [
    {
      label: "dcArduinoMeter",
      url: instance === "INV" ? `${env?.tpRoot}/dataCenter/allOfPowerMeters` : `${env?.tpRoot}/dataCenter/dcService`,
      src: dcImage,
      access: ["DCPOWER"],
      description: "dcArduinoMeterDesc"
    },
    {
      label: "performanceMonitor",
      url: instance === "INV" ? `${env?.tpRoot}/performance/performanceBrowser` : `${env?.tpRoot}/performance/trafficData`,
      src: perfmonImage,
      access: ["PERFMON"],
      description: "performanceMonitorDesc"
    },
    {
      label: "SD-WAN",
      url: `${env?.tpRoot}/sdWan/sites`,
      src: sdwanImage,
      access: ["SDWAN"],
      description: "sdWanDesc"
    },
    {
      label: "ddosSecurityService",
      url: `${env?.tpRoot}/ddos/sites`,
      src: ddosImage,
      access: ["DDOS"],
      description: "ddosSecurityServiceDesc"
    },
    {
      label: "dnsManagement",
      url: `${env?.tpRoot}/dns/management`,
      src: dnsImage,
      access: ["DNS"],
      description: "dnsManagementDesc"
    },
    {
      label: "fastlane",
      url: `${env?.tpRoot}/kubernetes/usage`,
      src: kubernetesImage,
      access: ["K8SM"],
      description: "fastlaneDesc"
    },
    {
      label: "soc",
      url: `${env?.tpRoot}/soc/events`,
      src: socImage,
      access: ["SOC"],
      description: "socDesc"
    },
  ];

  return (
    <Section hideBorder>
      <Grid container spacing={4}>
        {homePageCards.map(page => (
          <Rendered rendered={!!page.access?.some(r => customerContext.selectedContact?.roles?.includes(r))} key={page.label}>
            <Grid item xs={12} sm={6} lg={3} key={page.label + "_grid"}>
              <Link href={page?.url} target={page?.url || ""} style={{textDecoration: "none"}}>
                <Card
                  sx={{
                    maxWidth: 345,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}
                >
                  <CardActionArea>
                    <CardMedia sx={{height: 140}} image={page.src} title={page.componentName}/>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {languageContext.dictionary[page.label] || page.label}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {languageContext.dictionary[page.description] || page.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
          </Rendered>
        ))}
      </Grid>
    </Section>
  );
};

export default HomeMenuCards;
